import { http } from '../http'
import { mockGetTopics } from '@/mocks/topicsMock'

export async function getTopics() {
	// MOCK
	if (import.meta.env.VITE_AUTH_MOCK) {
		return mockGetTopics()
	}
	return http.get(`/topics`).then((response) => response.data)
}
